import React,{Component} from 'react'
// import {Redirect,Route,Switch} from 'react-router-dom'
import { Layout } from 'antd';
import {Header} from '../../components/header/header'
import OptimalRatio from '../optimal-ratio/optimal-ratio'
import Portfolio from '../portfolio/portfolio'
// import RiskReturn from '../optimal-ratio/risk-return/risk-return'
// import Test from '../test/test';
// import Account from '../user/account'
import './index.less'
import { IntlProvider } from 'react-intl';
import {saveTransLocalStorage,getTransLocalStorage} from '../utils/storageUtils'
import translateData from '../../assets/translations.json'
const { Content} = Layout;

const SUPPORTED_LOCALES = ['en', 'ja'];
const SUPPORTED_TARGETS = ['port', 'val', 'opt'];
const APP_TARGET = SUPPORTED_TARGETS.includes(process.env.REACT_APP_TARGET)
    ? process.env.REACT_APP_TARGET
    : 'opt';
const BUILD_LOCALE = SUPPORTED_LOCALES.includes(process.env.REACT_APP_BUILD_LOCALE)
    ? process.env.REACT_APP_BUILD_LOCALE
    : '';
const pageMap = {
    opt: OptimalRatio,
    val: OptimalRatio,
    port: Portfolio,
};
const PageComponent = pageMap[APP_TARGET] || OptimalRatio;

const getLocaleFromPath = () => {
    const locale = window.location.pathname.split('/').filter(Boolean).pop();
    return SUPPORTED_LOCALES.includes(locale) ? locale : null;
};

const getInitialLocale = () => BUILD_LOCALE || getLocaleFromPath() || getTransLocalStorage();

const buildLocalePath = (locale) => {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const hasLocale = SUPPORTED_LOCALES.includes(pathParts[pathParts.length - 1]);
    const baseParts = hasLocale ? pathParts.slice(0, -1) : pathParts;
    const nextParts = baseParts.length > 0 ? baseParts : [APP_TARGET];

    return `/${[...nextParts, locale].join('/')}`;
};


export default class Index extends Component{
  state = {
    locale : getInitialLocale(),
    flagCode : 'jp',
    translateData,
  };
    componentDidMount () {
        saveTransLocalStorage(this.state.locale);
        this.setFlagCode()
        
    }
    componentDidUpdate (prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            const locale = getLocaleFromPath();
            if (locale && locale !== this.state.locale) {
                saveTransLocalStorage(locale);
                this.setState({
                    locale,
                    flagCode: locale === 'ja' ? 'jp' : 'us'
                });
            }
        }
    }
    componentWillUnmount () {
    }

    setFlagCode = () => {
        const {locale} = this.state;
        this.setState({ flagCode: locale==='ja'?'jp':'us' });
    };



    //20260108 UEDA 昔のコードだと reload のせいで「毎回初期化」されて、デバッグもしづらい
    setLocale = () => {
        const { locale } = this.state;
        const newLocale = locale === 'ja' ? 'en' : 'ja';
        saveTransLocalStorage(newLocale);
        window.location.href = buildLocalePath(newLocale);
    };


    render(){
        const {locale,translateData,flagCode} = this.state;
        return (
            <IntlProvider locale={locale} messages={translateData[locale]}>
            <div style={{ justifyContent:'center', width: '100vw', minHeight:'100vh',margin:'auto'}}>
            <Layout style={{ minHeight: '100vh' }} >
                <Header  style={{ margin: '24px 16px 0',padding: 0,height:'80px'}} setLocale={this.setLocale} flagCode={flagCode} pageTitle/>
                <Content style={{ backgroundColor: 'white', flex: 1 }} >
                   <PageComponent key={APP_TARGET} id={APP_TARGET}/>
                </Content>
                {/* <Footer style={{ textAlign: 'center' ,backgroundColor:'white' , borderTop : 1}}><FormattedMessage id='CompanyFullName' /></Footer> */}
            </Layout>
            </div>
            </IntlProvider>

        )
    }
}
// const AppContent = () => {

//     return (
//       <>
//         <Switch>
//                         {/* <Route path='/home' component={Home} />
//                         <Route path='/jp-bond' component={JPBond} />
//                         <Route path='/pricing-result' component={PricingResult}/> */}
//                         <Route path='/account' component={Account}></Route>
//                         {/* <Route path='/inquires' component={Inquires}/>
//                         <Route path='/contact' component={Contact} />  */}
//                         <Route path='/port' component={Portfolio}/>    
//                         <Route path='/opt' render={() => <OptimalRatio key="opt" />} />    
//                         <Route path='/val' render={() => <OptimalRatio key="val" />}  />   
//                         {/* <Route path='/price-market' exact  component={PriceMarket} />    */}
//                         <Route path='/risk-return' exact  component={RiskReturn} />                       
//                         <Route path='/test' component={Test} />                        
//                         <Redirect from='/' exact to='/port'/>      
//         </Switch>
//       </>
//     );
//   };
